import React from "react";
import "../styles/global.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {

  const getPages = () => {
    const pages = [];

    for (let i = 1; i <= totalPages; i++) {
      // Always show first & last
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - 1 && i <= currentPage + 1)
      ) {
        pages.push(i);
      } else if (
        (i === currentPage - 2 && i > 1) ||
        (i === currentPage + 2 && i < totalPages)
      ) {
        pages.push("...");
      }
    }

    return pages;
  };

  const pages = getPages();

  return (
    <nav className="pagination-main">
      <ul className="pagination mb-0">

        {/* Previous */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
          >
            &laquo;
          </button>
        </li>

        {/* Pages */}
        {pages.map((page, index) => (
          <li
            key={index}
            className={`page-item ${
              page === currentPage ? "active" : ""
            } ${page === "..." ? "disabled" : ""}`}
          >
            <button
              className="page-link"
              onClick={() => page !== "..." && onPageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}

        {/* Next */}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
          >
            &raquo;
          </button>
        </li>

      </ul>
    </nav>
  );
};

export default Pagination;